// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3J76Q","inputWrap":"styles_inputWrap__LQppL","input":"styles_input__17EdN"};